/**
 * HTMLElement.addEventListener('elementQueryResize', function (e) {}, false);
 */

// This object is "private" and should not be expose
var eQuery = {

    //
    // Variables
    //

    // Class name used has a selector
    classname: "element-query",
    // Data attribute name used to store information (and has selector)
    datasize: "data-eq",
    // Data attribute containing a unique ientifier once initialise
    datauid: "data-eq-uid",
    // Integer for unique ID generation
    uid: 0,
    // An object to store informations
    storage: {
        index: [], // Array with all data key
        data: {}  // Key => Object
    },
    // Reference to custom resize event
    resizeEvent: null,

    //
    // Functions
    //

    consoleTimeStamp: function(str) {
        return; // Skip...
        if(console.timeStamp) {
            console.timeStamp(str);
        }
    },

    // Use requestAnimationFrame if possible for
    // better rendre performance
    requestAnimationFrame: function(fn) {
        if (window.requestAnimationFrame) {
            window.requestAnimationFrame(fn);
        } else {
            fn();
        }
    },

    // Return a unique identifier
    getUniqueId: function() {
        eQuery.uid++;
        return "uid" + eQuery.uid;
    },

    // Convert PX to attribute selector
    convertWidth: function(width) {

        // The goal is to represent a numeric value as a string usin increment.
        // Here is an example with an increment of 50, an a step in entities
        // each 2 increment.
        //
        // Ex : a       = 0
        //      aa      = 50
        //      aab     = 100
        //      aabbc   = 200

        // Element width
        var intWidth = parseInt(width);
        // Increment for each iteration
        var intIncrement = 50;
        // Entities used to represent increment (max 52)
        var arrEntities = ['a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z',
                    'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
        // Number of increment before using an other entities
        var intNbIncPerEntities = 2;
        // String representing the numeric value using increment
        var strNumeric = "";

        // Build the string representation of all width equal, or lower, to the element width
        for (var i = 0; i <= intWidth; i+= intIncrement) {
            // Find the entitie to use (key)
            var intEntitiesKey = Math.floor(i/(intIncrement*intNbIncPerEntities));
            // No more entite available (break)
            if(intEntitiesKey > (arrEntities.length-1) ) { break; }
            // Add an entitie to the string
            strNumeric += arrEntities[intEntitiesKey];
        };
        
        return strNumeric;
    },

    // Read Operation
    //
    // This function will trigger a "layout", so execute all read
    // operation in batch.
    read: function(uid) { 
        eQuery.storage.data[uid].width = eQuery.storage.data[uid].dom.offsetWidth;
    },

    // Write Operation
    //
    // This function will trigger a "layout", so execute all write
    // operation in batch.
    write: function(uid) {
        // Update size attribute
        eQuery.storage.data[uid].dom.setAttribute(eQuery.datasize, eQuery.convertWidth(eQuery.storage.data[uid].width));
        // Trigger update event
        eQuery.storage.data[uid].dom.dispatchEvent(eQuery.resizeEvent);
    },

    // Update ONE HTMLElement
    // This is not base on "index" object.
    //
    // This function doesn't use "request animation frame", and
    // is consider "synchronous", but can cause performance issue
    // if misuse.
    update: function(dom) {
        // Get UID
        var uid = dom.getAttribute(eQuery.datauid);
        // Read
        eQuery.read(uid);
        // Write
        eQuery.write(uid);
        // Timeline mark
        eQuery.consoleTimeStamp("elementQuery: Update");
    },

    // Update ONE HTMLElement
    // 
    // This function use "request animation frame", is consider 
    // "asynchronous", and is the best for performance.
    updateAsync: function(dom) {
        // Request Animation Frame
        eQuery.requestAnimationFrame(function(){eQuery.update(dom);});
        // Timeline mark
        eQuery.consoleTimeStamp("elementQuery: Update Async");
    },

    // Update ALL HTMLElement using Element-Query
    // This update is base on the "index" object
    //
    // This function doesn't use "request animation frame", and
    // is consider "synchronous", but can cause performance issue
    // if misuse.
    updateAll: function() {
        // Read ALL
        for (var i = eQuery.storage.index.length - 1; i >= 0; i--) {
            eQuery.read(eQuery.storage.index[i]);
        };
        // Write ALL
        for (var i = eQuery.storage.index.length - 1; i >= 0; i--) {
            eQuery.write(eQuery.storage.index[i]);
        };
        // Timeline mark
        eQuery.consoleTimeStamp("elementQuery: Update All");
    },

    // Update ALL HTMLElement using Element-Query
    // 
    // This function use "request animation frame", is consider 
    // "asynchronous", and is the best for performance.
    updateAllAsync: function() {
        // Request Animation Frame
        eQuery.requestAnimationFrame(eQuery.updateAll);
        // Timeline mark
        eQuery.consoleTimeStamp("elementQuery: Update All Async");
    },

    // Register a dom element
    register: function(dom) {
        // Do not "register" if it's already done...
        if(!dom.hasAttribute(eQuery.datauid))
        {
            // Get a unique identifier
            var uid = eQuery.getUniqueId();

            // Apply unique identifier
            dom.setAttribute(eQuery.datauid, uid);

            // Add to index
            eQuery.storage.index.push(uid);
            eQuery.storage.data[uid] = {
                uid: uid,
                dom: dom,
                width: 0
            };
            
            // Add function to trigger update
            dom.elementQueryUpdate = function() {
                eQuery.update(this);
            };

            // Add function to trigger update (async)
            dom.elementQueryUpdateAsync = function() {
                eQuery.updateAsync(this);
            };
        }
    },

    // Init
    init: function(dom) {

        eQuery.consoleTimeStamp("elementQuery: Init");
        
        // HTMLCollection
        if (dom instanceof HTMLCollection || dom instanceof NodeList) {
            for (var i = 0; i < dom.length; i++) {
                eQuery.register(dom[i]);
            };
        } 
        // Let's try as an HTMLElement
        else {
            eQuery.register(dom);
        }

        // Trigger update all
        eQuery.updateAll();
        
    }
};

// Expose the "elementQuery" to be used
// has an API
window.elementQuery = {
    init: eQuery.init,
    update: eQuery.updateAll,
    updateAsync: eQuery.updateAllAsync
}

// Create a resize event that will be triggered after
// the update of width information
eQuery.resizeEvent = document.createEvent('Event');
eQuery.resizeEvent.initEvent('elementQueryResize', true, true);

// Init has soon the HTML was parse
document.addEventListener("DOMContentLoaded", function(event) {
    eQuery.init(document.getElementsByClassName(eQuery.classname));
});

// Update on window resize
window.onresize = function(e) {
    eQuery.updateAllAsync();
};


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/element-query/element-query.js
 ** module id = 44
 ** module chunks = 0 1
 **/